export const PHONE_INPUT_DEFAULT_PLACEHOLDER = '(000) 000 00 00';

export const DEFAULT_COUNTRY = 'US';

export const COMMON_COUNTRIES: string[] = ['US', 'IT'];

export const EXTENDED_COUNTRIES: string[] = ['US', 'IT', 'UA', 'PL', 'SE', 'TR'];

// Mirrors IS_PROD in libs/shared/core/src/constants/env.constants.ts.
const NON_PROD_ENV_NAMES = ['dev', 'qa', 'stage', 'e2e', 'local'];
const isProdEnv = !NON_PROD_ENV_NAMES.some((env) => import.meta.env.VITE_API_ORIGIN?.includes(env));

export const DEFAULT_COUNTRIES: string[] = isProdEnv ? COMMON_COUNTRIES : EXTENDED_COUNTRIES;
